<template>
  <div class="wt2-sg wt2-masthead-story-back-icon" @click="onClick">
    <i class="wticon wticon-chevron-left1" /> Back
  </div>
</template>

<script>
import app from 'app';
import _ from 'lodash-extended';
import Vue from 'vue';
import EmbedmentController from '../../controllers/EmbedmentController';

export default Vue.extend({
  data: () => ({
    locked: false,
  }),

  methods: {
    onClick: _.debounce(
      function () {
        if (this.locked) {
          return;
        }
        this.$_lock();
        app.storyController.save();
        EmbedmentController.confirmLeave().then((res) => {
          this.$_navigate2Shortcut().then(_.noop, this.$_unlock);
        }, this.$_unlock);
      },
      app.TIME.MENTAL.λ,
      { leading: true, trailing: false }
    ),

    $_lock() {
      this.locked = true;
    },

    $_unlock() {
      this.locked = false;
    },

    $_exit() {
      return new Promise((resolve, reject) => {
        app.storyController
          .exit({
            type: 'exit',
            save: true,
            navigationOverride: true,
          })
          .done(() => {
            this.$_navigate2Shortcut();
            resolve();
          })
          .fail(reject);
      });
    },

    $_navigate2Shortcut() {
      return new Promise((resolve) => {
        app.state.enableNavigation();
        app.navigate2Shortcut({ route: 'dashboard' });
      });
    },
  },
});
</script>
